// extracted by mini-css-extract-plugin
export default {"container":"OfflineModal-module__container"};